module.exports = __webpack_public_path__ + "static/media/icon-manage-class-report.d0641628.svg";